import React, { useEffect, useState } from "react";
import { get, postAPI } from "../../../ApiService";
import Swal from "sweetalert2";

function PreScreenChooseTemplate(props){
    const [selectedTemplate, setSelectedTemplate] = useState()
    const [projectTemplateList, setProjectTemplateList] = useState()
    const [isAddingTemplate, setIsAddingTemplate] = useState(false)

    useEffect(() => {
        getTemplatelist()
    },[])

    const getTemplatelist = async() => {
        let res = await get('/project/prescreen/template/list');
        if(res?.status === 1){
            setProjectTemplateList(res?.payload)
        }
    }
    const addTemplateToProject = async() => {
        if (!selectedTemplate || isAddingTemplate) {
            return;
        }
        setIsAddingTemplate(true);
        try {
            let payload = {
                projectDetailID: parseInt(props?.detail?.projectDetailID),
                templateID: selectedTemplate
            }
            let res = await postAPI('/project/precsreen/map-question-from-template/', payload)
            Swal.fire({
                text: res.message,
            })
            props?.mappedQue()
        } finally {
            setIsAddingTemplate(false);
        }
    }
    return (<>
        <div className="mb- ">
            <div>
                <label htmlFor="Choosetemplate" className="form-label mb-0">Choose Template</label>
                <div className='d-flex'>
                    <select
                        id="Choosetemplate"
                        className="form-select"
                        data-choices
                        data-choices-sorting="true"
                        onChange={(e) => setSelectedTemplate(e.target.value)}
                    >
                        <option value={""} disabled selected>Select Template</option>
                        {projectTemplateList?.map((row) => {
                            return (
                                <>
                                    <option value={row?.ID}>{row?.title}</option>
                                </>
                            )
                        })}
                    </select>
                    <button
                        type="button"
                        className="btn btn-primary mx-2"
                        onClick={addTemplateToProject}
                        disabled={isAddingTemplate || !selectedTemplate}
                    >
                        {isAddingTemplate ? 'Adding...' : 'Add'}
                    </button>
                </div>
            </div>

        </div>
    </>)
}
export default PreScreenChooseTemplate